import { render } from "./personalTax.vue?vue&type=template&id=45f0bffb&scoped=true"
import script from "./personalTax.vue?vue&type=script&lang=js"
export * from "./personalTax.vue?vue&type=script&lang=js"

import "./personalTax.vue?vue&type=style&index=0&id=45f0bffb&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f0bffb"]])

export default __exports__